import client from '../../base-api';

const serviceURL = '/course-socio-therapy-coaching-price';

const courseSocioTherapyCoachingService = {

    getPriceList(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },

    getPrice(priceId: number) {
        return client.get(`${serviceURL}/${priceId}`);
    },

    postPrice(courseData: any) {
        return client.post(`${serviceURL}`, courseData);
    },

    putPrice(courseData: any, priceId: number) {
        return client.put(`${serviceURL}/${priceId}`, courseData);
    },

    deletePrice(priceId: number) {
        return client.delete(`${serviceURL}/${priceId}`);
    },
}

export default courseSocioTherapyCoachingService;